import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ReplenishYourGoodBacteriaBacterialVaginosisComponent } from '@components/consultation-request/upsells/replenish-your-good-bacteria/bacterial-vaginosis/replenish-your-good-bacteria-bacterial-vaginosis.component';
import { ReplenishYourGoodBacteriaHemorrhoidsComponent } from '@components/consultation-request/upsells/replenish-your-good-bacteria/hemorrhoids/replenish-your-good-bacteria-hemorrhoids.component';
import { ReplenishYourGoodBacteriaHsvComponent } from '@components/consultation-request/upsells/replenish-your-good-bacteria/hsv/replenish-your-good-bacteria-hsv.component';
import { ReplenishYourGoodBacteriaMetforminComponent } from '@components/consultation-request/upsells/replenish-your-good-bacteria/metformin/replenish-your-good-bacteria-metformin.component';
import { ReplenishYourGoodBacteriaComponent } from '@components/consultation-request/upsells/replenish-your-good-bacteria/replenish-your-good-bacteria.component';
import { ReplenishYourGoodBacteriaUtiComponent } from '@components/consultation-request/upsells/replenish-your-good-bacteria/uti/replenish-your-good-bacteria-uti.component';
import { ReplenishYourGoodBacteriaYeastInfectionComponent } from '@components/consultation-request/upsells/replenish-your-good-bacteria/yeast-infection/replenish-your-good-bacteria-yeast-infection.component';
import { ReplenishYourGoodBacteriaZofranComponent } from '@components/consultation-request/upsells/replenish-your-good-bacteria/zofran/replenish-your-good-bacteria-zofran.component';
import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { ConsultationStorageService } from '@services/consultation-storage.service';

/**
 * Switcher component that dynamically displays the appropriate Replenish Your Good Bacteria upsell component based on
 * the consultation treatment type.
 */
@Component({
  selector: 'app-replenish-your-good-bacteria-switcher',
  standalone: true,
  imports: [
    CommonModule,
    ReplenishYourGoodBacteriaBacterialVaginosisComponent,
    ReplenishYourGoodBacteriaComponent,
    ReplenishYourGoodBacteriaHemorrhoidsComponent,
    ReplenishYourGoodBacteriaHsvComponent,
    ReplenishYourGoodBacteriaMetforminComponent,
    ReplenishYourGoodBacteriaUtiComponent,
    ReplenishYourGoodBacteriaYeastInfectionComponent,
    ReplenishYourGoodBacteriaZofranComponent,
  ],
  templateUrl: './replenish-your-good-bacteria-switcher.component.html',
})
export class ReplenishYourGoodBacteriaSwitcherComponent {
  public readonly ConsultationTreatmentTypes: typeof ConsultationTreatmentTypes = ConsultationTreatmentTypes;

  private consultationStorageService = inject(ConsultationStorageService);

  /**
   * Gets the current treatment type from the consultation storage service.
   */
  public get treatmentType(): ConsultationTreatmentTypes {
    return this.consultationStorageService.treatmentType;
  }
}
